import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TGetLiveAndLiveSimAccountsCountResponse } from "../../api/accounts/index.types";

export interface IHeliosAdminState {
  simAndLiveSimAccounts: {
    data: {
      liveSimCount: number;
      liveCount: number;
    };
    loading: boolean;
  };
}

export const initialState: IHeliosAdminState = {
  simAndLiveSimAccounts: {
    data: {
      liveSimCount: 0,
      liveCount: 0,
    },
    loading: false,
  },
};

const heliosAdminSlice = createSlice({
  name: "heliosAdmin",
  initialState,
  reducers: {
    fetchSimAndLiveSimAccountsRequest: (state) => {
      state.simAndLiveSimAccounts.loading = true;
    },
    fetchSimAndLiveSimAccountsSuccess: (
      state,
      action: PayloadAction<TGetLiveAndLiveSimAccountsCountResponse>
    ) => {
      state.simAndLiveSimAccounts.loading = false;
      state.simAndLiveSimAccounts.data = action.payload.data;
    },
    fetchSimAndLiveSimAccountsFailed: (state) => {
      state.simAndLiveSimAccounts.loading = false;
    },
  },
});

export const heliosAdminActions = heliosAdminSlice.actions;
export default heliosAdminSlice.reducer;
